export default __webpack_public_path__ + "static/media/ABB.31424b48.png";